export default __webpack_public_path__ + "static/media/BhawanaMaheshwari.245eabb5.jpeg";